import { render, staticRenderFns } from "./Screens.vue?vue&type=template&id=7c9470ed"
import script from "./Screens.vue?vue&type=script&lang=ts"
export * from "./Screens.vue?vue&type=script&lang=ts"
import style0 from "./Screens.vue?vue&type=style&index=0&id=7c9470ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports